export default __webpack_public_path__ + "media/music/c97e974a0f18f69bfc01e3a214919e1f.mp3";